module.exports = __webpack_public_path__ + "img/16_35.c96cec67.png";